import { Component, OnInit } from '@angular/core';
import { SeleccionService } from '../../servicios/seleccion.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-ficha-respuesta',
  templateUrl: './ficha-respuesta.component.html',
  styleUrls: ['./ficha-respuesta.component.css']
})
export class FichaRespuestaComponent implements OnInit {

  public nombreBeca: string = ""; public detBeca: string = ""; public indBeca: string = "";
  public vecGrupos = []; public vecAsignacion = []; public vecOpciones = []; public vecOtros = []; public vecGrupoOtros = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.verDatosReponde();
    this.verGrupoRespuesta();
    this.verOtrosRespuesta();
  }
  //MOSTRAR LA INFORMACION DE UNA ENCUESTA SELECCIONADA Y RESPONDIDA
  async verDatosReponde() {
    const resEnc = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(15, localStorage.getItem('localResponde'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEnc.success) {
      this.nombreBeca = resEnc.encuesta[0]['strNombreEnc']
      this.indBeca = resEnc.encuesta[0]['strRecomendacionEnc']
    }
    else
      this.alerti.message('No se encntró información de la encuesta Seleccionada');
  }
  //MOSTRAR EL LISTADO DE TODOS LOS GRUPOS DE UNA FICHA RESPONDIDA
  async verGrupoRespuesta() {
    this.cargando.abrir();
    this.vecGrupos = []; this.vecAsignacion = []; this.vecOpciones = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(16, localStorage.getItem('localResponde'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecGrupos = resGrupo.encuesta;
      this.verRespuesRespuesta();
    }
    else
      this.alerti.error('La ecnuesta selecciona no dispone de preguntas en ese momento');
    this.cargando.cerrar();
  }
  //MOSTRAR EL LISTADO DE TODAS LAS PREGUNTAS DE UNA FICHA RESPONDIDA
  async verRespuesRespuesta() {
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(17, localStorage.getItem('localResponde'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecAsignacion = resGrupo.encuesta;
      this.verOpcionRespuesta();
    }
    else
      this.alerti.error('La ecnuesta selecciona no dispone de preguntas en ese momento');
  }
  //MOSTRAR EL LISTADO DE TODAS LAS OPCIONES DE UNA FICHA RESPONDIDA
  async verOpcionRespuesta() {
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(18, localStorage.getItem('localResponde'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success)
      this.vecOpciones = resGrupo.encuesta;
    else
      this.alerti.error('La encuesta selecciona no dispone de preguntas en ese momento');
  }
  //MOSTRAR EL LISTADO DE TODAS LAS OPCIONES DE UNA FICHA RESPONDIDA
  async verOtrosRespuesta() {
    this.vecOtros = []; this.vecGrupoOtros = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(24, localStorage.getItem('localResponde'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      this.vecGrupoOtros = resGrupo.encuesta;
      this.vecOtros = resGrupo.encuesta;
    }
  }
  imprimirRespuestas() {
    let divToPrint = document.getElementById('divImprime').innerHTML;
    let newWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    newWindow.document.open();
    newWindow.document.write(`
        <html>
        <head>
        <title>Print tab</title>
        <style> </style>
        </head>
        <body onload="window.print();window.close()">${divToPrint}
        </body>
        </html>
        `);
    newWindow.document.close();
  }
}
